import { Dimension } from 'types/common_types';
import utils from '../products/products.utils';

import type { ProductTemplateAPIData } from 'types/catalog_types';

// For now, a lot of the getter methods on this class just reuse existing util functions.
// In time, if this class gets used more often than those utils, we can refactor
// that logic here and get rid of the utils

export default class Product {
  private _product: ProductTemplateAPIData;

  // Public
  rotation: number = 0;
  customSize?: Dimension;

  constructor(product: ProductTemplateAPIData) {
    this._product = product;
  }

  get data() {
    return this._product;
  }

  get isCustomSize() {
    return utils.isCustomSizeProduct(this._product);
  }

  get width() {
    return this.size.width;
  }

  get height() {
    return this.size.height;
  }

  /** Get the string representation of the aspect ratio filter group -- eg, 3:2, 1:1, etc */
  get aspectRatioFilter() {
    return this._product.filter_group
      .split(',')
      .find((s) => s.match(/aspect_ratio/i))
      ?.split('/')[1];
  }

  get filters() {
    return utils.getProductFilters(this._product);
  }

  matchesFilter(filter: string) {
    if (filter === 'All' || filter === '') {
      return !this.isCustomSize;
    }

    if (filter === 'Aspect Ratio') {
      return !!this.aspectRatioFilter;
    }

    return this.filters.indexOf(filter) > -1;
  }

  private get size() {
    if (this.isCustomSize && !this.customSize) {
      return { height: 0, width: 0 };
    }

    const config = { ...this.customSize, rotation: this.rotation };
    return utils.calculateProductSize(this._product, { ...config, rotation: this.rotation });
  }
}
